<template>
  <div
    class="fts-table-edit-display-container"
    :class="{'fts-scrollbar': overflowAuto}"
  >
    <table 
      class="fts-table-edit fts-table-edit-display" 
      :class="{ 'table-edit--sticky-header': stickyHeader }"
    >
      <tr>
        <th v-for="column in getColumns" :key="column.id" :style="getColumnWidth(column)">
          <div class="col-label">
            <div class="col-label-name">{{getColumnLabel(column)}}</div>
            <i 
              class="col-label-icon" 
              :class="getIcon(column.type)" 
              v-if="hideLabelIcon !== true"
            ></i>
          </div>
        </th>
      </tr>
      <tr v-for="item in formData" :key="item.id">
        <td v-for="column in getColumns" :key="column.id" :style="getColumnWidth(column)">
          <fts-display
            :item="column"
            :form-data="item"   
            :vector-id="vectorId"
            :view="view"
            :share-form="shareForm"
            in-table
            class="form-display-borderless" 
            :class="getElementClass(column)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import commons from "../commons/commons";

export default {
  props: {
    formData: Array,
    item: Object,
    vectorId: [ Number, String ],
    comfortDesign: Boolean, 
    overflowAuto: Boolean,
    view: Boolean,
    shareForm: Boolean,
    stickyHeader: Boolean,
    hideLabelIcon: Boolean
  },
  methods: {
    getDisplayClass(item) {
      if (
        item.input == 'boolean' ||
        item.input == 'toggle' ||
        item.type === 1
      ) {
        return "table-display-boolean";
      } else if (
        item.input == 'integer' ||
        item.type === 2
      ) {
        return "table-display-integer";
      } else if (
        item.input == 'number' ||
        item.type === 3 ||
        item.type === 4
      ) {
        return "table-display-number";
      } else if (
        item.input === 'imageUpload' ||
        item.input === 'imagesUpload' ||
        item.input === 'fileUpload' ||
        item.input === 'filesUpload' ||
        item.type === 10 ||
        item.type === 11 ||
        item.type === 12 ||
        item.type === 13
      ) {
        return "table-display-attachment";
      } else if (
        item.input == 'signature' ||
        item.type === 29
      ) {
        return "table-display-signature";
      }
    },
    getElementClass(item) {
      if (item.input == 'boolean' || item.input == 'toggle' || item.type === 1) {
        return "te-yes-no-display";
      } else if (item.input == 'integer' || item.type === 2) {
        return "te-integer-display";
      } else if (item.input == 'number' || item.type === 3 || item.type === 4 ) {
        return "te-number-currency-display";
      } else if (!this.shareForm && (item.input == 'signature' || item.type === 29)) {
        return "te-signature-display";
      }
    },
    getColumnWidth(item) {
      let minWidth = 150 //default minWidth
      if (item.columnWidth) {
        return {
          'width': item.columnWidth + "px",
          'minWidth': item.columnWidth + "px",
          'max-width': item.columnWidth + "px"
        }
        // minWidth = item.columnWidth
      } else if (item.display || item.input === 'display' || item.readOnly) {
        minWidth = 150
      } else if (item.input === 'imageUpload' || item.input === 'imagesUpload' || item.input === 'fileUpload' || item.input === 'filesUpload') {
        minWidth = 250
      } else if (item.input === 'boolean') {
        minWidth = 50
      } 
      return "minWidth:" + minWidth + "px"
    },
    getColumnLabel(item) {
      return item.label || item.displayName;
    },
    getIcon(typeId) {
      return commons.informationIcon(typeId);
    },
  },
  computed: {
		getColumns() {
      if (!this.item.fields && this.item.columns)
        this.item.fields = this.item.columns

      // type 18 === input hidden
      return this.item.fields.filter(x => (x.type !== 18 || x.input != 'hidden') && !x.hide && x.visible !== false)
    }
	},
  beforeCreate: function () {
		this.$options.components.FtsDisplay = require('./FTSDisplay').default
	}
}
</script>